var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaptureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 34.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2440_2390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 21.6667L27.8933 24.3334H23.6667C22.2 24.3334 21 25.5334 21 27.0001V43.0001C21 44.4667 22.2 45.6667 23.6667 45.6667H45C46.4667 45.6667 47.6667 44.4667 47.6667 43.0001V27.0001C47.6667 25.5334 46.4667 24.3334 45 24.3334H40.7733L38.3333 21.6667H30.3333Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 41C38.0899 41 41 38.0899 41 34.5C41 30.9101 38.0899 28 34.5 28C30.9101 28 28 30.9101 28 34.5C28 38.0899 30.9101 41 34.5 41Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2440_2390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(18 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureIcon);
export default __webpack_public_path__ + "static/media/captureIcon.e3899804da514f328941bee33bbf59bf.svg";
export { ForwardRef as ReactComponent };